import { atom } from 'recoil';



export const updatePreviewSettingAtom = atom({
    key: 'updatePreviewSettingAtom',
    default: {}
});

export const updatePreviewCategoryListAtom =  atom({
    key: 'updatePreviewCategoryListAtom',
    default: []
});
